import { graphqlAjax } from '..'
import { gql } from 'apollo-boost'
import { ROLEID } from '@GUTIL/hardCode'

export default {
  /**
   * Query
   */
  getAllDepartments: params => {
    const query = gql`
      query($in: DepartmentsFilterInput!) {
        allDepartments(in: $in) {
          data {
            id
            name
            divisions {
              id
              name
            }
            sections {
              id
              name
            }
            order_checkers {
              id
              nickname
              username
            }
            report_viewers {
              id
              nickname
              username
            }
            creator {
              id
              username
            }
            updater {
              id
              username
            }
            created_at
            updated_at
          }
          meta {
            total
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },

  getDepartment: params => {
    const query = gql`
      query($id: Int!) {
        department(id: $id) {
          id
          name
          divisions {
            id
            name
          }
          sections {
            id
            name
          }
          order_checkers {
            id
          }
          report_viewers {
            id
          }
        }
      }
    `
    return graphqlAjax('get', query, params)
  },

  getDepartmentSelectedOptions: () => {
    const query = gql`
      query(
        $divisionIn: DivisionsFilterInput!
        $accountIn: AccountsFilterInput
        $sectionIn: SectionsFilterInput!
      ) {
        allDivisions(in: $divisionIn) {
          data {
            id
            name
          }
        }

        allAccounts(filter: $accountIn) {
          data {
            id
            nickname
            username
            roles {
              id
            }
          }
        }

        allSections(in: $sectionIn) {
          data {
            id
            name
          }
        }
      }
    `
    return graphqlAjax('get', query, {
      divisionIn: {
        is_department_unbinded: true,
        base_filter: { page: 1, per_page: -1 }
      },
      accountIn: {
        role_ids: [ROLEID.ORDER_CHECKER, ROLEID.REPORT_VIEWER],
        base_filter: { page: 1, per_page: -1 }
      },
      sectionIn: {
        is_department_unbinded: true,
        base_filter: { page: 1, per_page: -1 }
      }
    })
  },

  /**
   * Mutation
   */
  createDepartment: (params, opts = {}) => {
    const mutation = gql`
      mutation($in: CreateDepartmentInput!) {
        createDepartment(in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  },

  updateDepartment: (params, opts = {}) => {
    const mutation = gql`
      mutation($id: Int!, $in: UpdateDepartmentInput!) {
        updateDepartment(id: $id, in: $in)
      }
    `
    return graphqlAjax('post', mutation, params, opts)
  }
}
